import React, { useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Star } from 'lucide-react';
import { testimonials } from '../mock/mockData';

const Testimonials = () => {
  return (
    <section className="py-12 md:py-20 bg-gradient-to-b from-white via-orange-50 to-amber-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 md:mb-4">
            What Our Clients Say
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            Real experiences from travelers who discovered Cape Town with us
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {testimonials.map((testimonial) => (
            <Card 
              key={testimonial.id}
              className="hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              <CardContent className="p-4 md:p-6">
                {/* Rating */}
                <div className="flex items-center space-x-1 mb-3 md:mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="text-[#6B0B0B] fill-[#6B0B0B]" size={16} />
                  ))}
                </div>

                {/* Testimonial Text */}
                <p className="text-gray-700 mb-4 md:mb-6 leading-relaxed text-sm md:text-base">
                  "{testimonial.text}"
                </p>

                {/* Tour Badge */}
                <div className="mb-3 md:mb-4">
                  <span className="inline-block bg-red-100 text-[#6B0B0B] text-xs font-semibold px-2 md:px-3 py-1 rounded-full">
                    {testimonial.tour}
                  </span>
                </div>

                {/* Author Info */}
                <div className="flex items-center space-x-2 md:space-x-3 pt-3 md:pt-4 border-t border-gray-200">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover"
                  />
                  <div>
                    <div className="font-semibold text-gray-900 text-sm md:text-base">{testimonial.name}</div>
                    <div className="text-xs md:text-sm text-gray-500">{testimonial.location}</div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
